import { cn } from "@/lib/utils";

type BrandMarkProps = {
  /** Hide the wordmark (collapsed sidebar). */
  compact?: boolean;
  size?: number;
  className?: string;
  showAdminTag?: boolean;
};

/**
 * The real Hriatna Eng blue mark (public/hriatna-eng-192x192.png) with the
 * name in bold blue. Never redraw the logo.
 */
const BrandMark = ({ compact = false, size = 30, className, showAdminTag = false }: BrandMarkProps) => (
  <span className={cn("inline-flex items-center gap-2.5 min-w-0", className)}>
    <img
      src="/hriatna-eng-192x192.png"
      alt={compact ? "Hriatna Eng" : ""}
      width={size}
      height={size}
      className="shrink-0 block"
      style={{ width: size, height: size }}
    />
    {!compact && (
      <span className="font-bold text-[17px] leading-[22px] tracking-[-0.2px] text-[#2F5BD3] dark:text-[hsl(var(--blue-ink))] truncate">
        Hriatna Eng
      </span>
    )}
    {!compact && showAdminTag && (
      <span className="h-[22px] px-2 rounded-full bg-background/70 text-ink-2 text-xs font-bold leading-[22px] whitespace-nowrap">
        Admin
      </span>
    )}
  </span>
);

export default BrandMark;
